<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
      <div class="tu-class">
        <el-form :model="formData" ref="ruleForm" status-icon :rules="rules" label-position="left" label-width="80px" size="default">
          <div class="table-container">
            <el-row :gutter="20" justify="middle" align="center">
              <el-col :span="24">
                <div class="grid-content">客户信息表</div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"> <div class="grid-content">客户名称</div> </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-input v-model="formData.customerName" clearable></el-input>
                </div>
              </el-col>
              <el-col :span="4"><div class="grid-content">业务</div></el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-input v-model="formData.salesman" clearable></el-input>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"> <div class="grid-content">创建登录账号</div> </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-radio-group v-model="createSysUser" @change="handleSysUserRadioChange">
                    <el-radio :label="1" value="1">是</el-radio>
                    <el-radio :label="0" value="0">否</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
              <el-col :span="4"> <div class="grid-content">用户昵称</div> </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-input v-model="userName" clearable :disabled="isUserNameDisabled"></el-input>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content">公司地址</div></el-col>
              <el-col :span="20">
                <div class="grid-content">
                  <el-input v-model="formData.companyAddress" clearable></el-input>
                </div
              ></el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content">分成模式</div></el-col>
              <el-col :span="20">
                <div class="grid-content">
                  <el-radio-group v-model="formData.commissionModel" :disabled="isCommissionModelDisabled">
                    <el-radio :label="'0'">按比例</el-radio>
                    <el-radio :label="'1'">底价</el-radio>
                    <el-radio :label="'2'">流量池</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content">使用设备及场景描述</div></el-col>
              <el-col :span="20">
                <div class="grid-content">
                <el-input v-model="formData.useDevice" clearable ></el-input>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content-image">使用设备图片</div></el-col>
              <el-col :span="20">
                <div class="grid-content-image">
                  <el-image style="width: 70vh; height: 200px" :src="formData.useDevicePicture" :preview-src-list="[formData.useDevicePicture]"></el-image>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content">联系人</div></el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-input v-model="formData.linkman" clearable></el-input>
                </div>
              </el-col>
              <el-col :span="4"><div class="grid-content">联系人电话</div></el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <el-input v-model="formData.linkmanPhone" clearable></el-input>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content-image">公司营业执照图片</div>
              </el-col>
              <el-col :span="20">
                <div class="grid-content-image">
                  <el-image style="width: 70vh; height: 200px" :src="formData.businessLicensePicture" :preview-src-list="[formData.businessLicensePicture]"></el-image>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="4"><div class="grid-content">备注</div></el-col>
              <el-col :span="20">
                <div class="grid-content">
                  <el-input v-model="formData.remark" clearable></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 审批意见
        <div class="nr-class">
          <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
            <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p class="yjp-class">
            <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
          </p>
          <el-button type="primary" @click="submitFlowComment" style="margin-top: 20px;">提交</el-button>
        </div>
      </h3>
    </div>
  </div>
</template>
<script>
  import { processInstanceImage } from "@/api/api.js";//流程图
  import { submitTask , getCustomerInfo } from "@/api/api.js";//审批意见提交

  export default {
    name:'flowCustomerAct',
    data() {
      return{
        formData: {},
        isAdmin: false,
        userName: null,
        createSysUser: null,
        isUserNameDisabled: false,
        isCommissionModelDisabled: false,
        rules: {
          /*userName: [
            { required: true, message: "用户昵称", trigger: "blur" }
          ],*/
        },
        processId:'',
        id:'',
        str:"",
        queryParams:{
          status: null,
          remark: null
        },
        source:[
          {
            value: 1,
            label: "同意"
          },
          {
            value: 2,
            label: "不同意"
          },
        ],
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
        gaibianurl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
        file:""
      }
    },

    methods: {
      handleSysUserRadioChange(val) {
          if(val == 0) {
              this.isUserNameDisabled = true;
              this.isCommissionModelDisabled = true;
          }
      },
      initDataProcessImage(){
        let params ={
          processInstanceId: this.processId
        }
        processInstanceImage(params).then(res=>{
          this.str = res.data
        });
      },
      initData() {
        getCustomerInfo({ id: this.id }).then((res) => {
          this.formData = res.data.data;
        });
      },
      // 提交
      submitFlowComment(){
        if (!this.createSysUser) {
          this.createSysUser = '0';
        }
        if (this.createSysUser == '1') {
          if (!this.userName) {
            return this.$message.error("创建登录账号：用户昵称不能为空");
          }
          if (!this.formData.commissionModel) {
            return this.$message.error("创建登录账号：分成模式不能为空");
          }
        }
        if (!this.queryParams.remark || !this.queryParams.status) {
          return this.$message.error("请输入审批内容或结果");
        }
        let params = {
          ...this.queryParams,
          taskId: null,
          processInstanceId: this.processId,
          userName: this.userName,
          createSysUser: this.createSysUser
        }
        params.customerInformationDto = this.formData;
        submitTask(params).then(res=>{
          if(res.data.code == 200){
            this.$store.dispatch('tagsView/delView', this.$route);
            this.$router.push({ path: `/shipment/customerInformation` });
            this.$notify({
              title: '成功',
              message: '审批成功',
              type: 'success'
            });
          }
        })
      },

    },
    created() {
      this.processId =  this.$route.query.processId ;
      this.id =  this.$route.query.id ;
      this.isAdmin = this.$store.getters.user.roleType == "0" || this.$store.getters.user.roleType == "1";
    },
    mounted() {
      this.initDataProcessImage()
      this.initData()
    },
  };
</script>
<style scoped lang="less">
  .el-row {
    //   margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 0px;
    //   min-height: 36px;
    border: 1px solid #4d4d4d;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 46px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .grid-content-image {
    border-radius: 4px;
    min-height: 300px;
    padding: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  div.table-container {
    margin-top: 50px;
    margin-left: 220px;
    max-width: 1200px;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid black;
    table.table-layout {
      table-layout: fixed;
      border-collapse: collapse;
      width: 1080px;

      td.table-cell {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
        text-align: center;
      }
    }
  }
  .table-checkbox,
  .table-radio {
    display: table-cell;
    border: 1px solid black;
    text-align: left;
  }

  .add-button {
    margin-top: -340px;
    margin-right: -10px;
    float: right;
    position: relative;
  }
  .save {
    margin-top: 50px;
    margin-left: 750px;
    position: relative;
  }
  .text-input {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
  }
  .radio-input {
    vertical-align: middle;
    margin-top: -2px;
    margin-bottom: 1px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    // line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
    .nr-class{
      margin-top: 20px;
      margin-left: 10px;
    }
    .yjp-class{
      margin-top: 20px;
    }
  }
</style>


